export const baseURL = `${process.env.REACT_APP_API_PATH}/frontendRouter/`
export const imageUrlProfile = `${process.env.REACT_APP_API_PATH}/userProfile/`
export const imageUrlTravellers = `${process.env.REACT_APP_API_PATH}/travelerImage/`
export const imageUrlOthers = `${process.env.REACT_APP_API_PATH}/img/`
export const googleApiKey = `${process.env.REACT_APP_GOOGLE_API_KEY}`
export const currencyBaseURL = `${process.env.REACT_APP_CURRENCY_BASE_PATH}`;
export const currencyRateURL = `${process.env.REACT_APP_CURRENCY_RATE_PATH}`;
export const googlePhotoUrl = `${process.env.REACT_APP_GOOGLE_API_PATH}/photo?`
export const googlePlaceUrl = `${process.env.REACT_APP_GOOGLE_API_PATH}/textsearch/json?`
